/**
 * @prettier
 * @flow
 */

export const appVersion: string = '0.5.1';
